import Image from "next/image";

export default function ValuePropositions({
  topTitle,
  title,
  valuePropositions,
}) {
  return (
    <section className="my-16 flex flex-col items-center justify-center md:py-12 bg-white bg-center font-['Inter']">
      <div className="xl:max-w-4xl lg:max-w-4xl md:max-w-3xl container px-4 mx-auto" tabIndex={0}>
        <div className="flex flex-col items-center text-center text-maingray">
          <h3 className="max-w-4xl mb-8 main-top-title">
            {topTitle}
          </h3>
          <p className="body-text mb-16 xl:mb-24 mx-auto">
            {title}
          </p>
        </div>
      </div>
      <div className="xl:max-w-7xl lg:max-w-5xl md:max-w-3xl container px-4 mx-auto flex justify-center mb-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-14">
          {valuePropositions.map(({ title, text }) => (
            <div key={title} className="flex flex-col items-center text-center" tabIndex={0}>
              <Image width={41} height={41} src="/assets/images/layout/icons8-checkmark.svg" alt="Checkmark" />
              <h5 className="small-title py-3 px-4">
                {title}
              </h5>
              <p className="body-text px-12 descp" dangerouslySetInnerHTML={{__html: text}} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
